// components/CertificadoActionsMenu.jsx
import * as React from 'react';
import { BaSeActionItem, BaSeLoadingSpinner } from '@base/react';
import { ActionItemWrapper } from '../certificados-cliente-styled';

export const CertificadoActionsMenu = ({ actions, isLoading }) => {
  if (isLoading) {
    return (
      <ActionItemWrapper>
        <BaSeLoadingSpinner
          color="default"
          description="Carregando…"
          diameter={25}
          type="tertiary"
        />
      </ActionItemWrapper>
    );
  }

  if (!actions.length) return null;

  return (
    <ActionItemWrapper>
      <BaSeActionItem
        closeOnAction
        icon="ellipsis-v"
        position="bottom-right"
        size="small"
        minWidth="230px"
        items={actions}
      />
    </ActionItemWrapper>
  );
};
